(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/partials/qr-spinner.js') >= 0) return;  svs.modules.push('/modules/player-login/views/partials/qr-spinner.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.qr_spinner = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-qr-spinner\"></div>\n";
},"useData":true});
Handlebars.partials['svs-player_login-qr_spinner'] = svs.player_login.templates.qr_spinner;
})(svs, Handlebars);


 })(window);